import { type InputHTMLAttributes, forwardRef } from 'react';
import { Field } from './Field';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helper?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helper, className = '', id, ...props }, ref) => {
    const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

    return (
      <Field label={label} error={error} helper={helper} id={inputId} className={className}>
        <input ref={ref} id={inputId} className="field__input" {...props} />
      </Field>
    );
  },
);

Input.displayName = 'Input';
